export class CompanyInfo {
    public companyCreditCode?: string;
    public companyId!: string;
    public companyName?: string;
    public companyNameIdentity?: string;
    public companyStatus?: string;

    public static of(o: unknown): CompanyInfo {
        return Object.assign(new CompanyInfo(), o);
    }
}
